import { Popover } from '@nextui-org/react';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

export const StyledPopoverContent = styled(Popover.Content)`
  overflow: visible;
  border-radius: 0.5rem;
`;

export const PopoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.menu};
`;

export const ContentItem = styled.div`
  cursor: pointer;
  padding: 0.625rem 0.5rem;
  border-radius: 0.375rem;
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.fontSize};

  :hover {
    background: ${(props: ThemeProp) => props.theme.colors.main.c050};
    color: ${(props: ThemeProp) => props.theme.colors.content.default};
  }
`;
